function parseAdminEmails(raw: string | undefined): Set<string> {
  return new Set(
    (raw || '')
      .split(',')
      .map((email) => email.trim().toLowerCase())
      .filter(Boolean),
  );
}

export function isAdminEmail(email: string | undefined | null): boolean {
  const normalized = email?.trim().toLowerCase();
  if (!normalized) {
    return false;
  }

  const configuredEmails = parseAdminEmails(import.meta.env.VITE_ADMIN_EMAILS);
  if (configuredEmails.has(normalized)) {
    return true;
  }

  return import.meta.env.DEV && normalized.endsWith('@stellartrail.local');
}
